var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", {}, [
    _c("div", { staticClass: "block" }, [
      _vm.isCurrentRoot
        ? _c(
            "div",
            {
              staticClass:
                "overflow-x-scroll xxl:overflow-hidden fix-scrollbar",
              class: _vm.listStyles,
            },
            [
              _c(
                "nav",
                { staticClass: "-mb-px flex", class: _vm.navClass },
                [
                  _vm._t("default"),
                  _vm._l(_vm.options, function (option, i) {
                    return _c(
                      "a",
                      {
                        key: i,
                        staticClass:
                          "whitespace-no-wrap flex px-1.5 justify-center items-center h-10 font-normal text-lg customlineh focus:outline-none",
                        class: _vm.tabStyle(i),
                        attrs: { href: "#", selected: _vm.selectedIndex },
                        on: {
                          click: function ($event) {
                            $event.preventDefault()
                            return _vm.$emit("select", i)
                          },
                        },
                      },
                      [
                        _vm.routes[i]
                          ? _vm._t(_vm.routes[i], function () {
                              return [_vm._v(" " + _vm._s(option) + " ")]
                            })
                          : _c("span", { staticClass: "capitalize" }, [
                              _vm._v(" " + _vm._s(option) + " "),
                            ]),
                      ],
                      2
                    )
                  }),
                ],
                2
              ),
            ]
          )
        : _vm._e(),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }